/* Tone → token-utility mapping for terminal data polarity (delta direction,
 * timeline severity). Replaces the hand-authored .terminal-tone-* CSS classes:
 * the colors are the terminal signal family (good/warn/bad) plus the disabled
 * ramp step for neutral. */

export type Tone = "good" | "caution" | "bad" | "neutral"

export const toneTextClass: Record<Tone, string> = {
  good: "text-signal-good",
  caution: "text-signal-warn",
  bad: "text-signal-bad",
  neutral: "text-text-disabled",
}
